import CompositeArrayNodeBase from '../../../../framework/oop/composite/CompositeArrayNodeBase';
import Visitable from '../../../../framework/oop/visitor/Visitable';

import DatasetTreeNodeVisitor from './DatasetTreeNodeVisitor';

/**
 * Abstract dataset tree node item.
 */
abstract class DatasetTreeNode
  extends CompositeArrayNodeBase<DatasetTreeNode>
  implements Visitable<DatasetTreeNodeVisitor>
{
  private group = 0;
  private isHorizontalSlaveLayout = false;

  /**
   * Returns a group number associated with this dataset.
   *
   * Layout algorithm might use this value to group datasets in an
   * implementation-specific way.
   */
  public getGroup(): number {
    return this.group;
  }

  /**
   * Sets the optional group number to hint the layout algorithms about the
   * additional structure aside from the inherent parent-child relationships.
   *
   * @param group
   */
  public setGroup(group: number): void {
    this.group = group;
  }

  public getIsHorizontalSlaveLayout(): boolean {
    return this.isHorizontalSlaveLayout;
  }

  public setIsHorizontalSlaveLayout(isHorizontalSlaveLayout: boolean): void {
    this.isHorizontalSlaveLayout = isHorizontalSlaveLayout;
  }

  public abstract acceptVisitor(visitor: DatasetTreeNodeVisitor): void;
}

export default DatasetTreeNode;
